import {Divider, Skeleton} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {OrderCancellationButton} from '../../components'
import {useOrderCancellationButtonVisibility} from '../../components/OrderCancellationButton/hooks/useOrderCancellationButtonVisibility'
import {Order} from '../../Order.types'
import {OrderHistoryDetails} from '../OrderHistoryDetails'

import {DetailsField} from './DetailsField'
import {ExportDeliveriesButton} from './ExportDeliveriesButton'
import {getDeliveryInstructions} from './utils'

interface SideOrderDetailsProps {
  order?: Order
  customerId: string
  haulierId: string
  useHaulierView: boolean
  isFetching: boolean
}

export const SideOrderDetails: React.FC<SideOrderDetailsProps> = ({
  order,
  customerId,
  haulierId,
  useHaulierView,
  isFetching
}) => {
  const {t} = useTranslation()
  const isOrderCancellationButtonVisible = useOrderCancellationButtonVisibility(order)

  if (isFetching) return <Skeleton variant="rectangular" height={200} />

  if (!order) return null

  return (
    <>
      <DetailsField
        label={t('order.orderDetails.deliveryInstructions')}
        dataTestId="delivery-instructions"
        value={getDeliveryInstructions(order)}
      />
      <ExportDeliveriesButton
        order={order}
        customerId={customerId}
        haulierId={haulierId}
        useHaulierView={useHaulierView}
      />
      <OrderHistoryDetails order={order} />
      {isOrderCancellationButtonVisible && (
        <>
          <Divider variant="fullWidth" />
          <OrderCancellationButton key={order.orderId} order={order} />
        </>
      )}
    </>
  )
}
